import RestauranteCustoEntregaService from "@/services/RestauranteCustoEntregaService";

export const restauranteCustoEntrega = {
  namespaced: true,
  state: {
    restauranteCustoEntrega: {},
  },
  actions: {
    getRestauranteCustoEntregaOData({ commit }, payload) {
      return RestauranteCustoEntregaService.GetRestauranteCustoEntregaOData(
        payload
      ).then(
        (restauranteCustoEntrega) => Promise.resolve(restauranteCustoEntrega),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default restauranteCustoEntrega;
